import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocumentsChildList,
} from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";
import { RouterView, type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  applications: "Application.Applications",
  list: "Application.ApplicationList",

  base: "Application.ApplicationBase",
  view: "Application.ApplicationView",

  documents: "Application.ApplicationDocuments",
  documentsEdit: "Application.ApplicationDocumentsEdit",
  documentsNew: "Application.ApplicationDocumentsNew",
  notes: "Application.ApplicationNotes",
  noteEdit: "Application.ApplicationNoteEdit",
  noteNew: "Application.ApplicationNoteNew",
  // audit: "Application.ApplicationAudit",
};

export { names as applicationRouteNames };

const applicationRoutes: RouterOptions["routes"] = [
  {
    path: "/application",
    name: names.applications,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Applications",
          lookupGroups: ["ApplicationType"],
        },
        component: () => import("@/views/application/ApplicationList.vue"),
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/application/ApplicationBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Application View" },
            component: () => import("@/views/application/ApplicationView.vue"),
          },

          {
            path: "documents",
            name: names.documents,
            meta: { title: "Application Documents" },
            component: {
              render: () => <EntityDocumentsChildList resourceTypeKey="application" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentsEdit,
            meta: { title: "Edit Application Document", isForm: true },
            component: {
              render: () => <EntityDocumentForm resourceTypeKey="application" />,
            },
          },
          {
            path: "documents/new",
            name: names.documentsNew,
            meta: { title: "Create Application Documents", isForm: true },
            component: {
              render: () => <EntityDocumentMultipleForm resourceTypeKey="application" />,
            },
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Application Notes" },
            component: {
              render: () => <EntityNotes idField="applicationId" routeNamePrefix="Application.ApplicationNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Application Note", isForm: true },
            component: () => import("@/views/application/ApplicationNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Application Note", isForm: true },
            component: () => import("@/views/application/ApplicationNote.vue"),
          },
          // {
          //   path: "activity",
          //   name: names.audit,
          //   meta: { title: "Application Audit Activity" },
          //   component: {
          //     render: () => <EntityAudit entityType="Application" />,
          //   },
          // },
        ],
      },
    ],
  },
];
export default applicationRoutes;
